import React from "react";
//import "./styles.css";

import { Row, Col, Button, Modal, Form } from "react-bootstrap";
import Leftpanel from "../../components/leftpanel/leftpanel";
import HeaderPartTwo from "../../components/layout/header/header2";
import "./dashboard.css";
import {
  Banner_1,
  Shopping,
  MyAccntBanner,
  ReferFriend,
} from "../../assets/images";
import { useEffect } from "react";
import { Redirect } from "react-router-dom";
import { useState } from "react";
import axios from "axios";
import { message } from "antd";
import apiConfig from "../../config/api.config";
import LoadingOverlay from "react-loading-overlay";
import TravelPortalModel from "../../components/TravelPortalModal";

const DashboardPart = (props) => {
  const [user, setUser] = useState(
    localStorage.getItem("userDetails")
      ? JSON.parse(localStorage.getItem("userDetails"))
      : null
  );
  const [arriviaUserId, setArriviaUserId] = useState(
    user ? user.arriviaUserId : null
  );
  const [startLogin, setStartLogin] = useState(false);
  const [show, setShow] = useState(false);
  const [first, setFirst] = useState("");
  const [phone, setPhone] = useState("");
  const [city, setCity] = useState("");
  const [country, setCountry] = useState("");
  const [last, setLast] = useState("");
  const [address, setAddress] = useState("");
  const [loadTravel, setLoadTravel] = useState("");
  const [arrivia_password, setArriviaPassword] = useState("");
     const [arriviaLoader , setArriviaLoader] = useState(false);
  const modalClose = () => {
    setLoadTravel(false);
    setShow(false);
  };

  const handleFirst = (event) => {
    switch (event.target.name) {
      case "first":
        setFirst(event.target.value);
        break;
      case "last":
        setLast(event.target.value);
        break;
      case "first":
        setFirst(event.target.value);
        break;
      case "address":
        setAddress(event.target.value);
        break;
      case "city":
        setCity(event.target.value);
        break;
      case "phone":
        setPhone(event.target.value);
        break;
      case "arrivia_password":
        setArriviaPassword(event.target.value);
        break;

      default:
        setCountry(event.target.value);
        break;
    }
  };
  const modalShow = () => setShow(true);
  const arriviaRegister = async () => {
    let isRegistered = false;
    if (!first || !phone || !city || !country || !last || !address || !arrivia_password) {
      console.log(first);
      message.warning("Please fill up the form properly");
    } else {
     if(arrivia_password.length < 8) {
        message.warning("Password should be at least 8 characters");
        return;
      }
      setArriviaLoader(true);
      const config = {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("AuthToken")}`,
        },
      };
      let data = {
        firstName: first,
        lastName: last,
        phone,
        country,
        city,
        address,
        password: arrivia_password
      };
      await axios
      .post(`${apiConfig.api}user/arrivia_register`, data, config)
      .then((res) => {
        if (res.data.status) {
          modalClose();
          setArriviaLoader(false);
          setArriviaUserId(res.data.data);
          setStartLogin(true);
          message.warning("You are being redirected, please wait");
            let userDetails = JSON.parse(localStorage.getItem("userDetails"));
            userDetails.arriviaUserId = res.data.data;
            console.log(userDetails, "us");
            localStorage.setItem("userDetails", JSON.stringify(userDetails));
            isRegistered = true;
            window.open(apiConfig.arriviaRedirectUrl + res.data.data, "_blank")
          } else {
            setArriviaLoader(false);
            message.error("Something went wrong. Login failed!");
          }
        })
        .catch((err) => {
          setArriviaLoader(false);
          console.log("err", err);
          message.error(
            err.response.data.message ??
              "Something went wrong. Please try again letter"
          );
        });

      if (isRegistered) {
         modalClose();
        setArriviaLoader(false);
        message.success("User is successfully registered.");
      } else {
        setArriviaLoader(false);
      }
    }
  };
  useEffect(() => {
    if (!localStorage.getItem("AuthToken")) {
      var token = localStorage.getItem("AuthToken");
      // setToken(token)
      window.open("/login", "_self");
    }
  }, []);

  useEffect(() => {
    if (arriviaUserId && startLogin) arriviaLogin();
  }, [arriviaUserId]);

  const arriviaLogin = async () => {
    const config = {
      headers: { Authorization: `Bearer ${localStorage.getItem("AuthToken")}` },
    };
    if (!arriviaUserId) {
      modalShow();
      return 0;
    }
    setLoadTravel(true);
    await axios
      .post(`${apiConfig.api}user/arrivia_login`, {}, config)
      .then((res) => {
        if (res.data.status) {
          setLoadTravel(false);
          // message.success("Arrivia login successfull. Redirecting to dashboard. Please wait...");
          window.open(apiConfig.arriviaRedirectUrl + res.data.data, "_blank");
        } else {
          message.error("Something went wrong. Login failed!");
        }
      })
      .catch((err) => {
        console.log("err", err);
        setLoadTravel(false);
        message.error(
          err.response.data.message ??
            "Something went wrong. Please try again letter"
        );
      });
  };

  return (
    <div>
      <HeaderPartTwo userDetails={user} />
      <div className="main_cont">
        <Leftpanel
          arriviaLogin={() => {
            arriviaLogin();
          }}
        />
        <div className="right_cont">
          <div className="right_banner_banner_cnt">
            <Row>
              <Col lg="6" md="6" sm="12" className="right_innrBanner">
                <LoadingOverlay active={loadTravel} spinner text="Redirecting to TravelDeals Dashboard...Please wait..">
                  <div className="right_inner_inner_banner">
                    <a
                      href="#"
                      className="banner_box"
                      onClick={() => {
                        arriviaLogin();
                      }}
                    >
                      <img src={Banner_1} className="img-fluid" alt="" />
                      <div className="banner_overlay">Travel Deals</div>
                    </a>
                  </div>
                </LoadingOverlay>
              </Col>

              <Col lg="6" md="6" sm="12" className="right_innrBanner">
                <div className="right_inner_inner_banner">
                  <a
                    href={`${
                      process.env.REACT_APP_ENV === "PRODUCTION"
                        ? "https://tapi.tripvaletincentives.com/user/benifithub"
                        : "https://apistaging.tripvalet.com/user/benifithub"
                    }`}
                    className="banner_box"
                  >
                    <img src={Shopping} className="img-fluid" alt="" />
                    <div className="banner_overlay">
                      Shopping & Entertainment
                    </div>
                  </a>
                </div>
              </Col>

              <Col lg="6" md="6" sm="12" className="right_innrBanner">
                <div className="right_inner_inner_banner">
                  <a
                    href="#"
                    className="banner_box"
                    onClick={() => {
                      window.open(
                        "https://www.tripvalet.com/account/my-account"
                      );
                    }}
                  >
                    <img src={MyAccntBanner} className="img-fluid" alt="" />
                    <div className="banner_overlay">My Account</div>
                  </a>
                </div>
              </Col>

              <Col lg="6" md="6" sm="12" className="right_innrBanner">
                <div className="right_inner_inner_banner">
                  <a
                    href="#"
                    className="banner_box"
                    onClick={() => {
                      window.open("https://www.tripvalet.com/refer-others");
                    }}
                  >
                    <img src={ReferFriend} className="img-fluid" alt="" />
                    <div className="banner_overlay">Refer a friend</div>
                  </a>
                </div>
              </Col>
            </Row>
          </div>
        </div>
      </div>

     
      <TravelPortalModel
        show={show}
        modalClose={modalClose}
        first={first}
        last={last}
        phone={phone}
        address={address}
        city={city}
        country={country}
        arrivia_password={arrivia_password}
        arriviaLoader={arriviaLoader}
        handleFirst={handleFirst}
        arriviaRegister={arriviaRegister}
      />
    </div>
  );
};

export default DashboardPart;
